// @ts-nocheck

import { Select } from 'antd'
import { get } from 'lodash'
import PropTypes from 'prop-types'

import { FormFieldLayout } from '../../../generic'

/**
@description Renders the Antd Select Field

https://ant.design/components/select/

@param {string} className. Allows styles to be
passed down to parts of the select field.

@param {array} options. All options for the select field.
[
    { value: 'test', label: 'Test' },
]

@param {string} placeholder. Placeholder text for the
field.

@param {object} values. The stored values for the form.
Usually fields, but can be formState or something else.

@returns {function} AntdSelectField.
*/

export default function AntdSelectField(props) {
  const {
    className = 'lmc-antd-select-field',
    disabled,
    errors,
    formKey,
    options,
    onChange,
    placeholder,
    selectStyle,
    values,
    testId
  } = props

  const currentValue = get(values, formKey)
  const error = get(errors, formKey)

  const { Option } = Select

  return (
    <FormFieldLayout hasErrors={!!error} {...props}>
      <div
        className={className}
        data-testid={testId ? `${testId}-select-field` : 'select-field'}
      >
        <Select
          disabled={disabled}
          getPopupContainer={(triggerNode) => triggerNode}
          onChange={(value) =>
            onChange({
              key: formKey,
              value
            })
          }
          optionLabelProp="label"
          placeholder={placeholder}
          style={{
            ...styles.selectField,
            ...selectStyle
          }}
          value={currentValue}
          data-testid={
            testId ? `${testId}-select-field-select` : 'select-field-select'
          }
        >
          {options.map((option) => {
            const { label, value, displayLabel } = option

            return (
              <Option
                key={`${label}-option`}
                value={value}
                label={displayLabel ?? label}
                data-testid={
                  testId
                    ? `${testId}-select-field-option`
                    : 'select-field-option'
                }
              >
                {label}
              </Option>
            )
          })}
        </Select>
      </div>
    </FormFieldLayout>
  )
}

AntdSelectField.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  errors: PropTypes.array,
  formKey: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.array.isRequired,
  placeholder: PropTypes.string,
  values: PropTypes.object.isRequired
}

const styles = {
  selectField: {
    width: 110
  }
}
